import React from 'react';
import { Container, Grid, Segment, Header } from 'semantic-ui-react';

let version = { version: 'unknown' };
try {
  version = require('../../version');
} catch (error) {}

export const HealthPage = () => {
  return (
    <div>
      <Container>
        <Grid centered padded>
          <Grid.Column style={{ maxWidth: 500 }}>
            <Segment>
              <Grid columns={1}>
                <Grid.Row>
                  <Grid.Column textAlign="center">
                    <Header as="h3">
                      App: version={version ? version.version : 'unknown'},
                      status=OK
                    </Header>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>
          </Grid.Column>
        </Grid>
      </Container>
    </div>
  );
};
